/**
 * 로컬 개발 시 Admin 로그인 우회 여부
 * - localhost에서만 동작
 * - .env에 REACT_APP_DEV_ADMIN_BYPASS=true 설정 필요
 * - 배포 시 이 변수를 설정하지 않으면 우회 비활성화
 */
export const isDevAdminBypassEnabled = (): boolean => {
  if (typeof window === 'undefined') return false
  const isLocalhost =
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1'
  const bypassFlag = process.env.REACT_APP_DEV_ADMIN_BYPASS === 'true'
  return isLocalhost && bypassFlag
}
